<div class="w-full">
  <div class="header mb-6 md:mb-8 flex flex-col gap-4 md:gap-6 justify-center text-center">
    <h4>{{ 'dashboard.userType' | translate }}</h4>
    <span>{{ 'dashboard.pleaseSelectTheType' | translate }}</span>
  </div>
  <div class="w-full flex flex-col gap-6 scrollable-area">
    @for (userType of userTypeList; track userType.userType) {
      <div
        class="user-type w-full flex flex-row rounded-lg px-6 py-4"
        [ngClass]="{ selected: userType?.userType === selectedUserType }"
        (click)="onUserTypeClick(userType?.userType)"
      >
        <div class="flex-1 user-type-info flex flex-col">
          <span class="user-type-info-title font-bold">{{ userType?.title | translate }}</span>
          <span class="user-type-info-description max-w-[183px] md:max-w-[300px]">{{
            userType?.description | translate
          }}</span>
        </div>
        <div class="flex flex-row items-center">
          <img [src]="userType?.imageSrc" class="w-[3.5rem] md:w-[5.5rem]" />
        </div>
      </div>
    }
  </div>
  <div *nzModalFooter class="flex justify-end gap-4 h-12">
    <korviu-button type="button" color="tertiary" (click)="onContinueClick()" class="w-full">
      {{ 'common.continue' | translate }}
    </korviu-button>
  </div>
</div>
